import { Direction, FlowComponentRenderContext } from "../../interface/functionalityInterface";

export const OUTLINE_COLOR = "#121212";

export const getTeeTransform = (direction: Direction) =>
  direction === "down"
    ? undefined
    : direction === "left"
      ? "rotate(90 50 50)"
      : direction === "up"
        ? "rotate(180 50 50)"
        : "rotate(-90 50 50)";

export const renderStraightArrow = ({
  isHorizontal,
  pipeArrowDirection,
  arrowColor,
}: FlowComponentRenderContext) => {
  if (isHorizontal) {
    return (
      <polygon
        points={
          pipeArrowDirection === "right"
            ? "84,50 72,43 72,57"
            : "16,50 28,43 28,57"
        }
        fill={arrowColor}
      />
    );
  }

  return (
    <polygon
      points={
        pipeArrowDirection === "down"
          ? "50,84 43,72 57,72"
          : "50,16 43,28 57,28"
      }
      fill={arrowColor}
    />
  );
};

export const renderStraightPulse = (
  { isHorizontal, pulseColor }: FlowComponentRenderContext,
  strokeWidth = 11
) =>
  isHorizontal ? (
    <line
      x1="8"
      y1="50"
      x2="92"
      y2="50"
      stroke={pulseColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
    />
  ) : (
    <line
      x1="50"
      y1="8"
      x2="50"
      y2="92"
      stroke={pulseColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
    />
  );
